import { Project } from '../projects/projects.types';
import {
	MapSelectorAction,
	MapSelectorListAction,
	MapSelectorSetSelectableAction
} from './map-selector.types';

export const MAP_SELECTOR_SELECT_MAP: string = 'MAP_SELECTOR_SELECT_MAP';
export const MAP_SELECTOR_DESELECT_MAP: string = 'MAP_SELECTOR_DESELECT_MAP';
export const MAP_SELECTOR_SET_SELECTED_LIST: string =
	'MAP_SELECTOR_SET_SELECTED_LIST';
export const MAP_SELECTOR_SET_SELECTABLE: string =
	'MAP_SELECTOR_SET_SELECTABLE';

export function mapSelectorSelectMap(project: Project): MapSelectorAction {
	return { type: MAP_SELECTOR_SELECT_MAP, payload: project };
}

export function mapSelectorDeselectMap(project: Project): MapSelectorAction {
	return { type: MAP_SELECTOR_DESELECT_MAP, payload: project };
}

export function mapSelectorSetSelectedList(
	projects: Project[]
): MapSelectorListAction {
	return { type: MAP_SELECTOR_SET_SELECTED_LIST, payload: projects };
}

export function mapSelectorSetSelectable(
	selectable: boolean
): MapSelectorSetSelectableAction {
	return { type: MAP_SELECTOR_SET_SELECTABLE, payload: selectable };
}
